document.addEventListener('click', function (e) {
  const poster = e.target.closest('.el-video__poster');
  if (!poster) return;

  const container = poster.closest('.el-video');
  const frame = container.querySelector('.el-video__frame');

  const videoId = poster.dataset.videoId;
  const type = poster.dataset.videoType;
  const src = poster.dataset.videoSrc;

  document.querySelectorAll('.el-video__frame iframe').forEach((iframe) => {
    iframe.src = 'about:blank';
  });

  document.querySelectorAll('.el-video__frame video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });

  document.querySelectorAll('.el-video__poster').forEach((p) => {
    p.style.display = '';
  });

  poster.style.display = 'none';

  setTimeout(() => {
    let html = '';

    if (type === 'youtube') {
      html = `
        <iframe
          class="el-video__iframe"
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0"
          allow="autoplay; encrypted-media; fullscreen"
          allowfullscreen
        ></iframe>
      `;
    }

    if (type === 'vimeo') {
      html = `
        <iframe
          class="el-video__iframe"
          src="https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&playsinline=1"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      `;
    }

    if (type === 'mp4') {
      html = `
        <video class="el-video__iframe" controls autoplay muted playsinline>
          <source src="${src}" type="video/mp4">
        </video>
      `;
    }

    frame.innerHTML = html;
  }, 0);
});